// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"_fd374a8","dropdown":"_be9e82a"};